import React from 'react'
import Loading from '../../assets/svg/Loading'
import { Box, Typography } from '@mui/material';
import getProjectConfig from '../../configs/projectConfigs';



const keyframes = `
    @keyframes fadeInOut {
      0% { opacity: 0.5; }
      100% { opacity: 1; }
    }
  
    @keyframes blink {
      0% { opacity: 0; }
      50% { opacity: 1; }
      100% { opacity: 0; }
    }
  `;
function LoadingPage() {
    const projectConfig = getProjectConfig();
    const preferredLanguage = localStorage.getItem('userLanguagePreference');


    const styles = {
        container: {
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "35px",
            color: projectConfig?.theme?.mainColor,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        dotsContainer: {
            display: "inline-flex",
            fontSize: "35px",
            fontWeight: "bold",
            color: projectConfig?.theme?.mainColor,
            width: "35px",
            justifyContent: "space-between",
            marginLeft: "5px",
            marginRight: "10px",
        },
        dot: {
            animation: "blink 1s infinite",
        },
        loadingText: {
            display: "inline-block",
            fontSize: "35px",
            fontWeight: "bold",
            color: projectConfig?.theme?.mainColor,
            animation: "fadeInOut .5s infinite alternate",
        },
    };
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: 4 }}>
            <img
                data-no-gallery={true}
                alt="logo"
                style={{
                    height: 280,
                    width: 280,
                    margin: '10px auto',
                    display: 'block',
                    objectFit: 'contain',
                    border: 'none',  // Explicitly remove the border
                    borderRadius: projectConfig?.LoadingBorderRadius || '50%',
                    boxShadow: 'none', // Explicitly remove the box shadow
                    background: "",

                }}
                src={projectConfig?.loadingLogo ? projectConfig?.loadingLogo : projectConfig?.logo}
            />
            {preferredLanguage === "ar" ? (
                <div style={styles.container}>
                    <style>{keyframes}</style>
                    <span style={styles.dotsContainer}>
                        <span style={{ ...styles.dot, animationDelay: "0.6s" }}>.</span>
                        <span style={{ ...styles.dot, animationDelay: "0.3s" }}>.</span>
                        <span style={{ ...styles.dot, animationDelay: "0s" }}>.</span>
                    </span>
                    <Typography
                        style={styles.loadingText}
                    >
                        جارى التحميل
                    </Typography>
                </div>
            ) : (
                <Loading />
            )}
        </Box>
    )
}

export default LoadingPage
